import { Patient } from "../../../api/patient.types";
import { AppointmentsViewAction } from "./appointments.view.types";

export const appointmentsViewPatientSetAction = (patient: Partial<Patient>): AppointmentsViewAction => ({ type: 'APPOINTMENTS_VIEW_PATIENT_SET', params: patient })
export const appointmentsViewPatientClearAction = (): AppointmentsViewAction => ({ type: 'APPOINTMENTS_VIEW_PATIENT_CLEAR' })

export const appointmentsViewActiveTabSetAction = (activeTab: string | number): AppointmentsViewAction => ({ type: 'APPOINTMENTS_VIEW_ACTIVE_TAB_SET', params: activeTab })
export const appointmentsViewActiveTabClearAction = (): AppointmentsViewAction => ({ type: 'APPOINTMENTS_VIEW_ACTIVE_TAB_CLEAR' })